/**
 * localStorage helpers for v0.1 identity + first-attempt lock.
 */

const KEY_DEVICE_ID = 'bos.deviceId';
const KEY_DISPLAY_NAME = 'bos.displayName';
const KEY_INSTRUCTIONS_DISMISSED = 'bos.instructionsDismissed';
const firstAttemptKey = (dayId: string): string => `bos.firstAttempt.${dayId}`;

function uuidv4(): string {
  const g = globalThis as { crypto?: Crypto };
  const c = g.crypto;
  // Browser-native if available.
  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID();
  }
  // Fallback (RFC4122 v4) — note: Math.random is fine here, this is identity not gameplay.
  const b = new Uint8Array(16);
  if (c && typeof c.getRandomValues === 'function') {
    c.getRandomValues(b);
  } else {
    for (let i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256);
  }
  b[6] = (b[6]! & 0x0f) | 0x40;
  b[8] = (b[8]! & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

export function getOrCreateDeviceId(): string {
  let id = localStorage.getItem(KEY_DEVICE_ID);
  if (!id) {
    id = uuidv4();
    localStorage.setItem(KEY_DEVICE_ID, id);
  }
  return id;
}

export function getDisplayName(): string | null {
  return localStorage.getItem(KEY_DISPLAY_NAME);
}

export function setDisplayName(name: string): void {
  localStorage.setItem(KEY_DISPLAY_NAME, name);
}

export function isFirstAttemptScored(dayId: string): boolean {
  return localStorage.getItem(firstAttemptKey(dayId)) === 'true';
}

export function markFirstAttemptScored(dayId: string): void {
  localStorage.setItem(firstAttemptKey(dayId), 'true');
}

export function instructionsDismissed(): boolean {
  return localStorage.getItem(KEY_INSTRUCTIONS_DISMISSED) === 'true';
}

export function dismissInstructions(): void {
  localStorage.setItem(KEY_INSTRUCTIONS_DISMISSED, 'true');
}
